export default function ({ $fire, $config, isDev }) {
  if (!isDev || $config.nodeEnv === 'production') {
    if (isDev) {
      self.FIREBASE_APPCHECK_DEBUG_TOKEN = true
    }
    $fire.appCheck.activate($config.appCheckSiteKey, true)
  }
}
